import { ChangeDetectorRef, Directive, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { DisplaySchema, SummitDisposing, SummitIdObject, ViewField } from '@summit/models';
import { ApiError } from '@summit/ui';

@Directive()
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class SummitControl<T extends SummitIdObject> extends SummitDisposing implements OnInit, OnChanges {
  @Input() label: string | undefined;
  @Input() form: FormGroup;
  @Input() groupName: string;
  @Input() fieldName?: (keyof T & string) & string;
  @Input() apiError: ApiError;
  @Input() schema: DisplaySchema<T> | false;
  @Input() displayHint: string;
  @Input() disabled: boolean;
  @Input() fieldFocus: boolean;
  @Input() nullableLabel: string;
  @Input() required: boolean;
  @Input() showClear?: boolean;
  @Input() readonly: boolean; //prime naming
  @Input() autocomplete: string; //case following standard should be a pass through to the input

  attribute: ViewField<T> | undefined;
  myControl: AbstractControl | null = null;
  protected cd: ChangeDetectorRef;

  constructor() {
    super();
    this.cd = inject(ChangeDetectorRef);
  }

  ngOnInit() {
    if (this.form === undefined && this.schema !== null && this.schema !== false) {
      console.warn(`[${this.fieldName}] Control didn't receive a Form Group`, typeof this);
    } else if (this.form) {
      if (!this.fieldName) {
        if (this.schema !== false)
          console.warn(`[${this.fieldName}] Control didn't receive a fieldName ${this.fieldName}`);
      } else {
        this.myControl = this.form?.get(this.fieldName);
        if (this.schema) {
          this.attribute = this.schema.getAttribute(this.fieldName as keyof T & string, this.groupName);
          //console.log(`[${this.fieldName}] Property: ${this.attribute?.propertyName}`, this.schema);
          if (!this.attribute) {
            console.warn(
              `[${this.fieldName}] Control could not find Attribute in group ${this.groupName ?? 'root'} in Tree`
            );
          }
        } else {
          if (this.schema !== false && this.schema !== null)
            console.warn(`[${this.fieldName}] Control didn't receive a display schema`);
        }
      }
    }
    this.label ??= this.attribute?.displayName ?? this.fieldName;
    this.displayHint ??= this.attribute?.displayHint ?? '';
    this.nullableLabel = this.nullableLabel ? this.nullableLabel : (this.attribute?.displayNullText ?? '');
    this.setDisableState();
    //if (this.fieldName == 'description') console.log('form', this.fieldName, this.form);
  }

  isRequired(): boolean {
    return (
      this.required ?? this.attribute?.validationMessages?.find((entry) => entry.type === 'required') !== undefined
    );
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.setDisableState();
  }

  setDisableState() {
    if (this.disabled) {
      //console.log(`[${this.fieldName as string}] Disabling ${this.fieldName as string}`);
      this.myControl?.disable();
    } else {
      //console.log(`[${this.fieldName as string}] Enabling ${this.fieldName as string}`);
      this.myControl?.enable();
    }
  }

  getName(): string {
    return this.groupName ? `${this.groupName}.${this.fieldName ?? ''}` : (this.fieldName ?? '');
  }
}
